import { useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { marked } from "marked";
import MentionsBlock from "./MentionsBlock";

//--
const CompanyFeedback = (props) => {
  const feedback = props.data;

  const advantages = feedback.advantages || [];
  const disadvantages = feedback.disadvantages || [];

  const [selectedAdvantage, setSelectedAdvantage] = useState(0);
  const [selectedDisadvantage, setSelectedDisadvantage] = useState(0);

  if (feedback && feedback.ai_analysis) {
    let mainText = feedback.ai_analysis;
    let strength = "High"; // default fall-back

    const strengthMatch = feedback.ai_analysis.match(/Evidence strength:\s*(\w+)/i);
    if (strengthMatch) {
      strength = strengthMatch[1];
      mainText = feedback.ai_analysis.replace(/Evidence strength:\s*\w+/i, "").trim();
    }

    const htmlContent = marked.parse(mainText);

    return (
      <div id="feedback" className="text-block pb-4">
        <div className="d-flex my-4 align-items-center">
          <Badge bg="primary-light" text="primary text-uppercase">
            Powered by vendorland AI
          </Badge>
          <hr className="w-100 m-0 border-1 " />
        </div>
        <h2 className="h4 mb-4">Vendorland AI Analysis</h2>
        <hr className="my-4" />
        
        <div className="mb-0">
          <h3 className="h5 mb-4">Overall Assessment</h3>
          <div 
            className="text-md mb-0 ai-analysis-content" 
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
          <div className="mt-4 d-flex align-items-center">
            <h3 className="h5 mb-0 me-2">Evidence strength:</h3>
            <Badge bg="primary-light" text="primary text-uppercase">{strength}</Badge>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="feedback" className="text-block pb-4">
      <div className="d-flex my-4 align-items-center">
        <Badge bg="primary-light" text="primary text-uppercase">
          Powered by vendorland AI
        </Badge>
        <hr className="w-100 m-0 border-1 " />
      </div>
      <h2 className="h4 mb-4 mb-md-5">Top mentions</h2>
      <Row className="gx-0 gx-5 mb-4 row-cols-1 row-cols-md-2" >
        {advantages.length > 0 &&
          <Col className="order-1 order-md-1">
            <MentionsBlock
              title="What clients love most"
              mentions={advantages}
              type="advantage"
              selectedMention={selectedAdvantage}
              setSelectedMention={setSelectedAdvantage}
            />
          </Col>
        }
        {disadvantages.length > 0 &&
          <Col className="order-3 order-md-2 mt-4 mt-md-0">
            <MentionsBlock
              title=" Not for everyone, and here's why"
              mentions={disadvantages}
              type="disadvantage"
              selectedMention={selectedDisadvantage}
              setSelectedMention={setSelectedDisadvantage}
            />
          </Col>
        }
        <Col className="order-2 order-md-3">
          {advantages[selectedAdvantage] &&
            <>
              <div className="text-sm fw-bold py-2">{advantages[selectedAdvantage]?.title}</div>
              <p className="text-sm text-muted">{advantages[selectedAdvantage]?.description}</p>
            </>
          }
        </Col>
        <Col className="order-4 order-md-4">
          {disadvantages[selectedDisadvantage] &&
            <>
              <div className="text-sm fw-bold py-2">{disadvantages[selectedDisadvantage]?.title}</div>
              <p className="text-sm text-muted">{disadvantages[selectedDisadvantage]?.description}</p>
            </>
          }
        </Col>
      </Row>
      <div>
        <h3 className="py-2 h5">Customer sentiment at a glance</h3>
        <p className="mb-0 rounded p-4 mb-2" style={{ backgroundColor: "#EAEDFE", color: "#2A124F" }}>{feedback.overview.summary}</p>
      </div>
    </div>
  )
}

export default CompanyFeedback;
